module.exports = __webpack_public_path__ + "static/media/8_The final lesson_TI.83de41bc.txt";